"use client"

import { useEffect } from "react"

import { persistUTMParams } from "@lib/util/utm-params"

function UTMParamStorage() {
  useEffect(() => {
    persistUTMParams()
  }, [])

  return null
}

export default UTMParamStorage
